import type { FC } from 'react';
import React from 'react';

import { xcss, Box } from '@atlaskit/primitives';

import { Reactions, ReactionContainerType, ReactionLocation } from '@confluence/reactions';
import { LIVE_PAGE_SUBTYPE } from '@confluence/live-pages-utils';
import { useBooleanFeatureFlag } from '@confluence/session-data';

export type LivePagesReactionsProps = {
	contentId: string;
	spaceId: string;
	isDisabled?: boolean;
	isContentCreationPanelOpen: boolean;
};

const templateSidebarWidth = 320;

const floatingContainerStyles = xcss({
	display: 'flex',
	position: 'fixed',
	justifyContent: 'right',
	bottom: 'space.300',
	right: 'space.100',
	zIndex: 'layer',
	transition: 'left 600ms',
});

const floatingContainerStylesForNewByline = xcss({
	display: 'flex',
	justifyContent: 'left',
	zIndex: 'layer',
	transition: 'left 600ms',
	marginLeft: 'space.100',
});

const containerStylesWhenPanelOpen = xcss({
	paddingRight: 'space.100',
	right: `${templateSidebarWidth}px`,
	transition: 'right 600ms',
});

export const LivePagesReactions: FC<LivePagesReactionsProps> = ({
	contentId,
	spaceId,
	isDisabled = false,
	isContentCreationPanelOpen,
}) => {
	const isNewLivePageBylineFeatureFlagEnabled = useBooleanFeatureFlag(
		'confluence.frontend.custom-sites.new-live-pages-byline',
	);
	const isCustomSitesPageTitleFFOn = useBooleanFeatureFlag(
		'confluence.frontend.custom-sites.page-header-and-title',
	);
	const isNewLivePageByline = isNewLivePageBylineFeatureFlagEnabled && isCustomSitesPageTitleFFOn;

	return (
		<Box
			xcss={[
				isNewLivePageByline ? floatingContainerStylesForNewByline : floatingContainerStyles,
				isContentCreationPanelOpen && containerStylesWhenPanelOpen,
			]}
		>
			<Reactions
				contentId={contentId}
				location={ReactionLocation.PAGE}
				containerId={spaceId}
				containerType={ReactionContainerType.PAGE}
				contentSubType={LIVE_PAGE_SUBTYPE}
				summaryViewEnabled
				readOnly={isDisabled}
			/>
		</Box>
	);
};
